import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import Notification from "../../elements/notification/Notification";
import MaterialPagination from "../../styles/materialPagination";
import BaseRatesLst from "./BaseRatesList";
import BaseRatesFilter from "./BaseRatesFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import { AppContext } from "../../../App";

import { StyledBaseRatesWrapper } from "../styledBaseRates";

const BaseRatesContainer = ({ type }) => {
  const [rates, setRates] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const { user } = useContext(AppContext);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "service.name": checkFilterItem(history, "service.name", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchRates = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/rate-bases" + filterUrl + "&base=1", userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setRates(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  // TODO Add pusher (it was just fetchRates)

  useEffect(() => {
    fetchRates();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledBaseRatesWrapper>
        <div className="base-rates-head">
          <BaseRatesFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <BaseRatesLst rates={rates} />
        {totalPageCount > 0 &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledBaseRatesWrapper>
    </>
  );
};

export default BaseRatesContainer;